import {action, makeAutoObservable} from "mobx"
import ProductsLogApi from "../../api/ProductsLogApi"
import Sku from "../entities/Sku"

class ProductLogsController {
    private _search_selected_page: number = 0

    constructor() {
        makeAutoObservable(this)
    }

    private _pages_count: number = 0

    get pages_count(): number {
        return this._pages_count
    }

    private _selected_page: number = 0

    get selected_page(): number {
        if (this.search_query) {
            return this._search_selected_page
        } else {
            return this._selected_page
        }
    }

    set selected_page(value: number) {
        if (this.search_query) {
            this._search_selected_page = value
        } else {
            this._selected_page = value
        }
        this.loadProductsList()
    }

    private _products_on_one_page: number = 30

    get products_on_one_page(): number {
        return this._products_on_one_page
    }

    set products_on_one_page(value: number) {
        this._products_on_one_page = value
    }

    private _search_query: string = ""

    get search_query(): string {
        return this._search_query
    }

    set search_query(value: string) {
        this._search_query = value
        this.loadProductsList()
    }

    private _skus: Sku[] = []

    get skus(): Sku[] {
        return this._skus
    }

    loadProductsList() {
        ProductsLogApi.getProductsList(this.selected_page, this.products_on_one_page, this.search_query).then(
            action("loadedProductsList", result => {
                const data = result.data.data
                this._pages_count = Math.ceil(data.count / data.pageCount)
                const skus = []
                for (const skuData of data.content) {
                    skus.push(new Sku(skuData))
                }
                this._skus = skus
            })
        )
    }
}

export const productLogsController = new ProductLogsController()